import FrontEndApiService from './frontend.api.service';
import {runAsPublic} from "@helpers/api-helper";

const AgentLicenseService = {
    async checkValidityFromExternalAuthorities({stateId, nrdsId, lastName}) {
        return await runAsPublic(async (config) => {
            return await FrontEndApiService.post(`${config.apiPrefix}/${config.apiVersion}/agent/license/check`, {
                stateId: stateId,
                nrdsId: nrdsId,
                lastName: lastName,
            });
        });
    },
    async isUnique({stateId, number, type}) {
        return await runAsPublic(async (config) => {
            return await FrontEndApiService.post(`${config.apiPrefix}/${config.apiVersion}/agent/license/is-unique`, {
                stateId: stateId,
                number: number,
                type: type,
            });
        });
    },
    async revalidateLicense(licenseUuid) {
        return await runAsPublic(async (config) => {
            var t = await FrontEndApiService.post(`${config.apiPrefix}/${config.apiVersion}/agent/license/${licenseUuid}/revalidate`);
            // console.log('agentLicense.service.js revalidateLicense() returned form endpoint', t);
            // TODO: should we be smart about this returned data when deciding to call checkLoggedSession() in packages/agent/app?
            // .... checkLoggedSession() has code that calls refreshUserData() -> effectively loading the new license
            return t;
        });
    },
};

export default AgentLicenseService;